import React, { type ReactElement } from 'react';
import TableActions from 'atom-components/table-actions-lite';
import Table from 'atom-components/table-lite/table';
import OrganisationUserOnlyMarkerBadge from 'feature-components/badges/marker-badges/organisation-user-only-marker-badge';
import DeallocateMarkerButton from 'pages/marking/components/deallocate-marker-button';
import type { BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import ReallocateResponseButton from './reallocate-response-button';

type Props = {
  responseId: number;
  allocatedMarkerId: number;
  allocatedOrganisationUser: BaseCustomerUser;
  onDeallocate: () => void;
  isLoading: boolean;
};

export default function TableRow({
  responseId,
  allocatedMarkerId,
  allocatedOrganisationUser,
  onDeallocate,
  isLoading
}: Props): ReactElement {
  return (
    <Table.Row>
      <Table.DataCell>
        <OrganisationUserOnlyMarkerBadge
          organisationUser={allocatedOrganisationUser}
          warnIfNotCurrentUser
        />
      </Table.DataCell>
      <Table.DataCell>
        <TableActions>
          <DeallocateMarkerButton
            responseId={responseId}
            allocatedMarkerId={allocatedMarkerId}
            allocatedOrganisationUser={allocatedOrganisationUser}
            onDeallocate={onDeallocate}
          />
          <ReallocateResponseButton
            responseId={responseId}
            allocatedMarkerId={allocatedMarkerId}
            allocatedOrganisationUser={allocatedOrganisationUser}
            onReallocate={onDeallocate}
            isLoading={isLoading}
          />
        </TableActions>
      </Table.DataCell>
    </Table.Row>
  );
}
